import { render, staticRenderFns } from "./accountInfo.vue?vue&type=template&id=7388ce07&scoped=true"
import script from "./accountInfo.vue?vue&type=script&lang=js"
export * from "./accountInfo.vue?vue&type=script&lang=js"
import style0 from "./accountInfo.vue?vue&type=style&index=0&id=7388ce07&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7388ce07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7388ce07')) {
      api.createRecord('7388ce07', component.options)
    } else {
      api.reload('7388ce07', component.options)
    }
    module.hot.accept("./accountInfo.vue?vue&type=template&id=7388ce07&scoped=true", function () {
      api.rerender('7388ce07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/accountManage/accountInfo.vue"
export default component.exports